import * as React from "react";

import {
	TModule,
	TModuleType,
	TTextModule,
	CouponType,
	Layout,
	TPlatform,
} from "services/page/admin";
import { ModuleInteraction } from "services/page/common";
import {
	TCombinedProductCommonExtend,
	TMagicBanner,
	TMultiBanner,
	TCDBannerExtend,
	TCombinedProductModule,
	TCombinedMultiBannerModule,
	TCombinedCouponCommonExtend,
} from "services/page/modules";

import {
	DTPlatform,
	getModuleData,
	getValidDataByPlatfrom,
	refreshCountDownModule,
} from "utils/playground/module";

import { PrmParams, sendPrmByUrl } from "utils/prm";
import {
	bannerPlaceholder,
	transformMagicLinks,
	transformNavIcons,
	tranformCouponInfo,
} from "utils/playground/banner";
import { transformBanner, transformBanners } from "utils/playground/banner";
import {
	fetchProductPosterRadio,
	handleProductModuleParam,
	setProductDisplayInfo,
} from "utils/playground/product";
import { WEB_WIDTH, WEB_MINWIDTH, WEB_GRID_GAP } from "../constants";
import { MainProps } from "../../index";

import { getSite } from "utils/url";
import { sendPrm } from "tyrande/lib/prm";
import { getGetCoupons, getUserInfo } from "utils/zeusFetch";
import { jumpToLogin } from "utils/login";
import { setSentryCatchOnRequest } from "utils/sentryEvent";
import MagicBanner from "./MagicBanner";
import CountdownBanner from "./CountdownBanner";
import WebTypography from "./WebTypography";
import CardBanner from "./CardBanner";
import WebCarousel from "./WebCarousel";
import Navigation from "./Navigation";
import WebSlideProducts, { WebSlideProductsProps } from "./WebSlideProducts";
import NormalProducts from "./NormalProducts";
import CouponCode, { CouponProps } from "./CouponCode";
import { TCountdownModule, TModuleProps } from "views/services/playground";
import { Platform } from "utils/runtime";

export default class Main extends React.Component<MainProps> {
	constructor(props: MainProps) {
		super(props);
		this.state = {};
	}
	// tslint:disable-next-line
	renderComponents = (item: TModule, index: number) => {
		const { runtime } = this.props;
		const { languageCode, platform } = runtime;
		const { header, ui } = item;
		let { layout } = item;
		const positionId = header.position || `floor${index + 1}`;
		const modProps: TModuleProps = {
			key: positionId,
			positionId,
			online: true,
			minWidth: WEB_MINWIDTH,
			width: WEB_WIDTH,
			language: languageCode,
		};

		const PrmCommonParams: PrmParams = {
			floor: index + 1,
			position: 1,
			platform: Platform.WEB,
		};
		const commonModuleData = getModuleData(item);
		const moduleData = getValidDataByPlatfrom(commonModuleData, DTPlatform.PC);

		switch (item.type) {
			case TModuleType.TNavIcons:
				const icons = (item.module as typeof item.module & TCombinedMultiBannerModule).pc
					?.banners;
				const { navs } = transformNavIcons(icons, runtime, PrmCommonParams);
				return <Navigation navModules={navs} {...modProps} />;
			case TModuleType.TRichText:
				const textModule = item.module as typeof item.module & TTextModule;
				return (
					<WebTypography
						{...modProps}
						bgColor={item.ui?.bgColor || "#fff"}
						content={textModule && textModule.content}
					/>
				);
			// 👇Carousel Banner|Card Banner|Cube
			case TModuleType.TNewMultiBanner:
				const multi_data: TMultiBanner = moduleData;
				const tBanners = transformBanners(
					multi_data?.banners || [],
					runtime,
					{
						...PrmCommonParams,
					},
					{
						maxWidth: 1200,
					},
				);
				if (item.layout?.interaction !== ModuleInteraction.None) {
					return (
						<CardBanner
							{...modProps}
							cardBanners={tBanners}
							placeholderBg={bannerPlaceholder}
							moduleIndex={index}
						/>
					);
				}
				return (
					<WebCarousel
						{...modProps}
						showArrow
						banners={tBanners}
						placeholderBg={bannerPlaceholder}
						moduleIndex={index}
					/>
				);
			// 👇 MagicBanner
			case TModuleType.TNewMagicBanner:
				const magicModule: TMagicBanner = moduleData;
				const magicBanner = transformBanner({ ...magicModule.banners[0] }, runtime, {
					...PrmCommonParams,
				});
				const magicModuleItems: any = transformMagicLinks(
					index,
					runtime,
					magicModule.items,
				);
				return (
					<MagicBanner
						{...modProps}
						banner={magicBanner}
						placeholderBg={bannerPlaceholder}
						onClick={sendPrmByUrl}
						linkItems={magicModuleItems}
						moduleIndex={index}
					/>
				);

			// 👇 CountDown 倒计时
			case TModuleType.TNewCountdown:
				const countDownModule: TCDBannerExtend = moduleData;
				const cBanner = transformBanner(
					{ ...countDownModule.banner },
					runtime,
					{
						...PrmCommonParams,
					},
					{
						maxWidth: 1200,
					},
				);
				return (
					<CountdownBanner
						{...modProps}
						banner={cBanner}
						timer={countDownModule.timer as TCountdownModule}
						actState={countDownModule.state as any}
						placeholderBg={bannerPlaceholder}
						onRefresh={refreshCountDownModule(item.id, {
							runtime,
							prm: PrmCommonParams,
						})}
						moduleIndex={index}
					/>
				);

			case TModuleType.TNewMultiProduct:
				const productModule: TCombinedProductModule = commonModuleData;
				let moduleExtend: TCombinedProductCommonExtend = {
					ui,
					layout,
				};
				if (commonModuleData?.pc) {
					moduleExtend = (productModule as TCombinedProductModule).pc;
					layout = moduleExtend?.layout;
				}

				const isRollable = layout?.interaction === ModuleInteraction.RollOver;
				const productProps = handleProductModuleParam({
					defaultVal: {
						...modProps,
						layout: { ...(layout as Required<Layout>), gap: WEB_GRID_GAP },
					},
					module: productModule,
					runtime,
					prm: PrmCommonParams,
					header,
					extend: moduleExtend,
					tagQuery: this.props.tagQuery,
				}) as WebSlideProductsProps;
				const posterRadio = fetchProductPosterRadio(moduleExtend?.ui?.shape);
				if (isRollable) {
					return (
						<WebSlideProducts
							{...productProps}
							posterRatio={posterRadio}
							productDisplayInfo={setProductDisplayInfo({
								isRollable,
								platform: TPlatform.Pc,
							})}
						/>
					);
				}
				return <NormalProducts {...productProps} posterRatio={posterRadio} />;
			case TModuleType.TNewCoupon:
				const cpoponModule: TCombinedCouponCommonExtend = moduleData;
				const props: CouponProps = {
					...modProps,
					placeholderBg: bannerPlaceholder,
					spmClick: (order: number) => {
						sendPrm({
							site: getSite(platform),
							page: "65",
							part: index + 1,
							content: order,
						});
					},
					language: runtime.languageCode,
					coupons: tranformCouponInfo(cpoponModule?.coupons, runtime),
					columnSize: cpoponModule?.layout?.columnNum,
					type: cpoponModule?.couponType || CouponType.ReceiveCoupon,
					getCoupons: async (code: string) => {
						if (
							!runtime?.sessionKey ||
							!(await getUserInfo(runtime, {
								onSentryCatch: setSentryCatchOnRequest,
							}))
						) {
							return jumpToLogin({
								isUat: runtime.isUat,
								isInApp: false,
								isMobile: false,
							});
						}
						return getGetCoupons(
							{
								isUat: runtime.isUat ? "true" : undefined,
								campaign_key: code,
								sid: runtime.sid,
								sessionkey: runtime?.sessionKey || "",
								language: languageCode,
								currency: runtime.currency,
								country: runtime.countryCode3,
							},
							false,
							runtime.isUat,
						);
					},
				};
				return <CouponCode {...props} />;
			default:
				return null;
		}
	};

	render() {
		const { frontModules } = this.props;
		return (
			<React.Fragment>
				{frontModules.map((item, index) => {
					return this.renderComponents(item, index);
				})}
			</React.Fragment>
		);
	}
}
